import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class HeaderService {
  private header: BehaviorSubject<boolean> = new BehaviorSubject(false);
  private customTitle: BehaviorSubject<string> = new BehaviorSubject('');
  
  get state(): Observable<boolean> {
    return this.header.asObservable();
  }
  
  get customTitleState(): Observable<string> {
    return this.customTitle.asObservable();
  }
  
  setState(value = false) {
    this.header.next(value);
  }
  
  setCustomTitle(title: string) {
    this.customTitle.next(title);
  }
  
  clearCustomTitle() {
    this.customTitle.next('');
  }
}
